import React, { useState } from "react"
import { setSessionPassword } from "../utils/utils"

const PasswordProtect = () => {
  const [password, setPassword] = useState("")

  const onSubmit = e => {
    e.preventDefault()
    setSessionPassword(password)
    window.location.reload() // Reload to apply protection
  }

  return (
    <div className="tech-password-container ftp">
      <h1 className="tech-password-header ftp">
        Welcome to The Kitchen
        <br />
        Technical Information Page
      </h1>
      <p>Please enter password to continue</p>
      <form onSubmit={onSubmit} className="tech-password-form">
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ padding: "10px", fontSize: "16px" }}
        />
        <button type="submit" style={{ padding: "10px"}}>
          Submit
        </button>
      </form>
    </div>
  )
}

export default PasswordProtect
